import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";

import { SVG } from "../../components";
import { InputTitleWrapper } from "../Input/styled";
import { TimeInputWrapper, TimeInputContainer } from "./styled";
import { useRef } from "react";
import { useEffect } from "react";
import { useElementSize } from "../../hooks";

const TimeInput = ({ id, title, value, setValue, minDate, disabled, hasError, autoComplete }) => {
  const inputRef = useRef(null);
  const { width } = useElementSize(inputRef);

  useEffect(() => {
    const portalElement = document.querySelector("#time-input-portal");

    if (!portalElement) return;

    const adjustSize = () => {
      if (portalElement) {
        const wrapper = portalElement.querySelector(".react-datepicker");

        if (!wrapper) return;

        wrapper.style.width = `${width}px`;

        const triangle = portalElement.querySelector(".react-datepicker__triangle");

        if (!triangle) return;

        setTimeout(() => (triangle.style.transform = `translate3d(${width / 2}px, 0px, 0px)`));
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        adjustSize();
      });
    });

    observer.observe(portalElement, {
      childList: true,
      subtree: true
    });

    adjustSize();

    return () => {
      observer.disconnect();
    };
  }, [width]);

  const validatePassedTime = (time) => {
    if (minDate) {
      const currentDate = new Date();
      const selectedDate = new Date(time);

      currentDate.setHours(minDate.getHours());
      currentDate.setMinutes(minDate.getMinutes());
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);

      return currentDate.getTime() <= selectedDate.getTime();
    }

    return true;
  };

  return (
    <TimeInputContainer
      ref={inputRef}
      data-testid="input-container"
      className={disabled ? "disabled" : hasError ? "error" : ""}>
      <InputTitleWrapper>
        <label htmlFor={id}>{title}</label>
      </InputTitleWrapper>
      <TimeInputWrapper value={value}>
        <DatePicker
          id={id}
          selected={value}
          onChange={(time) => setValue(time)}
          placeholderText={t(strCode.TIME_INPUT_PLACEHOLER)}
          dateFormat="h:mm aa"
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          showTimeCaption={false}
          filterTime={validatePassedTime}
          autoComplete={autoComplete ? autoComplete : "off"}
          disabled={disabled}
          portalId={"time-input-portal"}
        />

        <SVG.CalendarIcon />
      </TimeInputWrapper>
    </TimeInputContainer>
  );
};

TimeInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Date),
  setValue: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  noTime: PropTypes.bool,
  autoComplete: PropTypes.bool
};

export default TimeInput;
